/**
 * PlaybackButtons
 *
 * Note:
 * Use this in context of TimelineProvider only
 */

import React, { useContext, useMemo } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { TimelineContext } from "../../_utils/timeline";
import { connect } from "react-redux";
import { Flex, IconButton, Tooltip } from "@chakra-ui/react";
import { FaBackward, FaForward, FaPause, FaPlay } from "react-icons/fa";
import { useTranslation } from "react-i18next";

dayjs.extend(duration);

function PlaybackButtons(props) {
  const { t } = useTranslation(["common"]);
  const { isPlaying, play, pause, seek, currentTime, seekRelative } =
    useContext(TimelineContext);

  // Optimized playback
  return useMemo(() => {
    return (
      <Flex align="center" justify="center" data-click>
        <Tooltip
          hasArrow
          placement="top"
          label={t("backwards", { ns: "studio" })}
        >
          <IconButton
            onClick={() => {
              seekRelative(-3);
            }}
            color="gray.300"
            variant="unstyled"
            icon={<FaBackward />}
            display={["none", "none", "none", "flex"]}
            height={3}
            width={3}
          />
        </Tooltip>

        <Tooltip
          placement="top"
          hasArrow
          label={isPlaying ? t("pause") : t("play")}
        >
          <IconButton
            variant="unstyled"
            onClick={isPlaying ? () => pause() : () => play()}
            color="brand.primary"
            mx={4}
            height={6}
            width={6}
            icon={isPlaying ? <FaPause /> : <FaPlay />}
            sx={{
              svg: {
                h: "100%",
                w: "100%",
              },
            }}
          />
        </Tooltip>

        <Tooltip hasArrow placement="top" label={t("forward")}>
          <IconButton
            onClick={() => {
              seekRelative(3);
            }}
            color="gray.300"
            variant="unstyled"
            icon={<FaForward />}
            display={["none", "none", "none", "flex"]}
            height={3}
            width={3}
          />
        </Tooltip>
      </Flex>
    );
  }, [isPlaying, play, pause, seekRelative]);
}

PlaybackButtons.propTypes = {};

const mapStateToProps = (state) => ({
  motionStore: state.motionStore,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PlaybackButtons);
